<template>
  <div class="OAColums pointer">
    <div>
      <i :class="'iconfont '+getIcon(scope.row.applyTypeDesc)"></i>
      <span>【{{scope.row.applyName}}】</span>
      <span>{{scope.row.applyTime}}</span>
      <span>{{scope.row.applyTypeDesc}}</span>
    </div>
    <div :class="getClass(scope.row.status)">{{scope.row.statusDesc}}</div>
  </div>
</template>

<script>
export default {
  name: "OAColums",
  props: {
    scope: {
      default: null
    }
  },
  data() {
    return {
      colMaps: {
        1: "primary",
        2: "danger",
        3: "info",
        4: "success",
      },
      iconMaps: [
        { name: "出差", class: "icon-chuchai bg-warning" },
        { name: "外出", class: "icon-waichu bg-primary" },
        { name: "请假", class: "icon-qingjia bg-info" },
        { name: "报销", class: "icon-qianbao bg-success" }
      ]
    };
  },
  mounted() {},
  methods: {
    getClass(val) {
      return this.colMaps[val];
    },
    getIcon(val) {
      return _.find(this.iconMaps, { name: val }).class;
    }
  }
};
</script>
<style lang="scss">
.OAColums {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  line-height: 33px;
  :first-child {
    .iconfont {
      color: #fff;
      padding: 6px;
      border-radius: 50%;
      margin-right: 5px;
    }
  }
  :last-child {
    width: 80px;
    text-align: right;
  }
}
.tooltip {
  width: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/OAColums/OAColums.vue